module.exports = __webpack_public_path__ + "static/media/buy-gold.3df5d0e7.png";